// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__IQLA8","showPopup":"Popover_showPopup__3lZEC","popoverInfoline":"Popover_popoverInfoline__3BVg-","balance":"Popover_balance__EjVar"};